import { contractDate } from './planningDates';
export function contractRequestEmail({ action, contract, requestedDate, note, freelance, agency, recipientEmail }) {
  const format = value => contractDate(value)?.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" }) || 'Non renseignée';
  const label = action === 'extend' ? 'Prolongation' : action === 'stop' ? 'Arrêt' : 'Relance';
  const subject = `${label} du contrat ${contract.NumeroContrat || contract._id || ''} — ${contract.RaisonSociale || ''}`;
  if (action === 'remind') {
    const recipient = String(recipientEmail || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(recipient)) throw new Error('Email du client requis');
    const body = [
      'Bonjour,', '',
      `La mission de ${contract.NomPrenom || 'votre intérimaire'} se termine le ${format(contract.DateFinMission || contract.DateFin)} (contrat ${contract.NumeroContrat || 'non renseigné'}).`,
      'Souhaitez-vous prolonger cette mission ou confirmer sa fin à la date prévue ?',
      ...(note?.trim() ? ['', note.trim()] : []),
      '', 'Merci de nous faire part de votre décision.', '', 'Cordialement,', freelance.name || 'Votre interlocuteur',
    ].join('\n');
    return { subject, body, href: `mailto:${encodeURIComponent(recipient)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}` };
  }
  const body = [
    'Bonjour,', '',
    `Merci de traiter cette demande de ${label.toLowerCase()} dans le logiciel de paie.`, '',
    `Freelance : ${freelance.name || 'Non renseigné'}`,
    `Email du freelance : ${freelance.email || 'Non renseigné'}`,
    `Agence : ${agency || 'Non renseignée'}`,
    `Contrat : ${contract.NumeroContrat || 'Non renseigné'}`,
    `Identifiant du contrat : ${contract._id || 'Non renseigné'}`,
    `Avenant : ${contract.NumeroAvenant ?? 'Non renseigné'}`,
    `Client : ${contract.RaisonSociale || 'Non renseigné'}`,
    `Intérimaire : ${contract.NomPrenom || 'Non renseigné'}`,
    `Début actuel : ${format(contract.DateDebut)}`,
    `Fin actuelle : ${format(contract.DateFinMission || contract.DateFin)}`,
    ...(action === 'extend' ? [`Nouvelle date de fin souhaitée : ${format(requestedDate)}`] : action === 'stop' ? [`Date d’arrêt souhaitée : ${format(requestedDate)}`] : []),
    ...(note?.trim() ? ['', `Précisions : ${note.trim()}`] : []),
    '', 'Merci de me confirmer le traitement de cette demande.', '', 'Cordialement,', freelance.name || 'Le freelance',
  ].join('\n');
  return { subject, body, href: `mailto:contact@jm-interim.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}` };
}
